import { axiosCompanyPortalInstance } from "./";

const COMPANY_ROLES_PATH = "/company_roles";

/** GET /company_portal/v1/company_roles — list/search company roles. */
const getCompanyRoles = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get(COMPANY_ROLES_PATH, { ...config, params });

/** GET /company_portal/v1/company_roles/:id — show a single role + permissions. */
const getCompanyRole = (id) =>
  axiosCompanyPortalInstance.get(`${COMPANY_ROLES_PATH}/${id}`);

/** POST /company_portal/v1/company_roles — create a role with sparse permissions. */
const createCompanyRole = (data) =>
  axiosCompanyPortalInstance.post(COMPANY_ROLES_PATH, data);

/** PATCH /company_portal/v1/company_roles/:id — rename, toggle status, or
 * overwrite permissions. Sparse `permissions` array is allowed. */
const updateCompanyRole = ({ id, data }) =>
  axiosCompanyPortalInstance.patch(`${COMPANY_ROLES_PATH}/${id}`, data);

/** DELETE /company_portal/v1/company_roles/:id — destroy a role. Backend
 * blocks system roles and roles with assigned users (400 with localized
 * message). FE should already hide the trash for those cases. */
const deleteCompanyRole = (id) =>
  axiosCompanyPortalInstance.delete(`${COMPANY_ROLES_PATH}/${id}`);

export {
  getCompanyRoles,
  getCompanyRole,
  createCompanyRole,
  updateCompanyRole,
  deleteCompanyRole,
};
